import { dataOutstandingSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOutstandingSolid = /*#__PURE__*/createIcon(dataOutstandingSolid)
export default IconOutstandingSolid
